import arrowDonwWhite from './img/arrow-down-white.png'
import arrowDonwBlack from './img/arrow-down-black.png'
import map from './img/map.jpg'
import logotype from './video/logotype.mp4'
import trame from './img/trame.jpg'
import notification from './sounds/notification.mp3'
import mobileFlash from './sounds/mobileFlash.mp3'
import flashOff from './sounds/off.mp3'
import mobileUp from './sounds/mobileUp.mp3'
import mobileDown from './sounds/mobileDown.mp3'
import fingerprintDisadvandtage from './sounds/fingerprintDisadvandtage.mp3'
import fingerprintAdvandtage from './sounds/fingerprintAdvandtage.mp3'
import sliderEnd from './sounds/sliderEnd.mp3'
import sendNotif from './sounds/sendNotif.mp3'
import codeSound from './sounds/codeSound.mp3'

export const assetsToLoad = {
  arrowDonwWhite: { url: arrowDonwWhite, name: 'arrowDonwWhite', type: 'image' },
  arrowDonwBlack: { url: arrowDonwBlack, name: 'arrowDonwBlack', type: 'image' },
  map: { url: map, name: 'map', type: 'image' },
  trame: { url: trame, name: 'trame', type: 'image' },
  logotype: { url: logotype, name: 'logotype', type: 'video' },
  notification: { url: notification, name: 'notification', type: 'sound' },
  mobileFlash: { url: mobileFlash, name: 'mobileFlash', type: 'sound' },
  flashOff: { url: flashOff, name: 'flashOff', type: 'sound' },
  mobileUp: { url: mobileUp, name: 'mobileUp', type: 'sound' },
  mobileDown: { url: mobileDown, name: 'mobileDown', type: 'sound' },
  fingerprintDisadvandtage: { url: fingerprintDisadvandtage, name: 'fingerprintDisadvandtage', type: 'sound' },
  fingerprintAdvandtage: { url: fingerprintAdvandtage, name: 'fingerprintAdvandtage', type: 'sound' },
  sliderEnd: { url: sliderEnd, name: 'sliderEnd', type: 'sound' },
  sendNotif: { url: sendNotif, name: 'sendNotif', type: 'sound' },
  codeSound: { url: codeSound, name: 'codeSound', type: 'sound' }
}
